import Link from "components/Link"
import { PRICING_URL, PRODUCT_URL, CUSTOMERS_URL } from "constants/urls"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import Image from "components/ui/Image"

function WhyPresetSection() {
  return (
    <Container section>
      <div className="flex flex-col items-center gap-8 lg:flex-row lg:gap-16">
        <div className="lg:w-1/2">
          <Heading
            label="Why Preset"
            title={<>Enterprise SaaS powered by Apache Superset&trade;</>}
            subtitle={
              <>
                Explore your data with Preset&apos;s{" "}
                <Link href="/product/" className="text-lush hover:underline">
                  cloud-hosted
                </Link>
                ,{" "}
                <Link
                  href="/preset-managed-private-cloud/"
                  className="text-lush hover:underline"
                >
                  managed cloud
                </Link>
                ,{" "}
                <Link
                  href="/certified-superset/"
                  className="text-lush hover:underline"
                >
                  on-prem
                </Link>
                , or{" "}
                <Link
                  href="/embedded-dashboards/"
                  className="text-lush hover:underline"
                >
                  embedded
                </Link>{" "}
                analytics solutions.
              </>
            }
            decoration="line"
            size="large"
          />
        </div>
        <div className="hidden lg:block lg:w-1/2">
          <img
            src="/images/content/security-governance.jpeg"
            alt="Preset security, governance, and reliability"
            className="w-full rounded-lg"
          />
        </div>
      </div>
      <div className="mt-10 grid grid-cols-1 gap-x-5 gap-y-16 md:grid-cols-3 lg:mt-16 lg:gap-x-20">
        <Item
          title="Easy to create dashboards and find insights"
          description={
            <>
              Preset’s intuitive drag-and-drop user interface and fully
              interactive dashboards offer a seamless experience for business
              users. SQL-savvy analysts can utilize the SQL IDE to run ad-hoc
              queries.
            </>
          }
          linkText="Discover Preset Cloud"
          linkUrl={PRODUCT_URL}
        />
        <Item
          title="Instant time to dashboards and actions"
          description={
            <>
              Preset&apos;s dataset-centric approach enables anyone to
              immediately create their dashboards, freeing up valuable time for
              data teams. By containing only relevant columns, these datasets
              ensure fast, performant queries.
            </>
          }
          linkText="Read customer stories"
          linkUrl={CUSTOMERS_URL}
        />
        <Item
          title="Best pricing model and no vendor lock-in"
          description={
            <>
              Preset offers the most cost-effective BI solution. You have the
              flexibility to migrate your charts and dashboards to open-source
              Apache Superset.
            </>
          }
          linkText="See pricing"
          linkUrl={PRICING_URL}
        />
      </div>
    </Container>
  )
}

function Item({ icon, title, description, linkText, linkUrl }) {
  return (
    <div className="flex flex-col justify-between space-y-6">
      <div>
        {icon && (
          <div className="flex h-10 w-10 items-center">
            <Image className="w-full" src={icon} />
          </div>
        )}
        <h3 className={`text-2xl font-bold text-black${icon ? " mt-5" : ""}`}>
          {title}
        </h3>
        <p className="mt-4 text-base text-anchor">{description}</p>
      </div>
      <div>
        <Link className="text-lg font-bold text-lush lg:text-xl" href={linkUrl}>
          {linkText}
        </Link>
      </div>
    </div>
  )
}

export default WhyPresetSection
